const Land = {
    land: {
        land: 'Land',
        lands: 'Lands',
        add: 'Add land',
        seeAnimals: 'See animals',
        first: 'Welcome!!! You have not created any land, please create your fist land to start.',
        noAnimals: 'No animals yet in this land.',
        noDescription: 'No description',
        createMap: 'Create a map',
        size: 'Hectareas',
        location: 'Location',
        map: 'Map',
        owner: 'Owner',
        reader: 'Guest',
        editor: 'Colaborator',
        count: 'Count',
        loadingMap: 'Loading map...',
        sharedWith: 'Shared width'
    },
};

export default Land;
